export default __webpack_public_path__ + "player_icon_reminder_normal.svg";